import { ConciliationEmailReportType, LIST_TYPES } from "./conciliation-email-report-types";

interface EmailReportTabsProps {
  listType: ConciliationEmailReportType;
  onTypeChange: (value: ConciliationEmailReportType) => void;
}

export default function EmailReportTabs({ listType, onTypeChange }: EmailReportTabsProps) {
  return (
    <div className="flex border-b border-gray-200 mb-2 w-full overflow-x-auto hide-scrollbar whitespace-nowrap">
      {LIST_TYPES.map((item) => (
        <button
          key={item.value}
          type="button"
          className={`px-4 py-2 text-sm font-medium focus:outline-none transition-colors relative ${
            listType === item.value ? "text-[#2E0D1E]" : "text-gray-400 hover:text-[#2E0D1E]"
          }`}
          onClick={() => onTypeChange(item.value as ConciliationEmailReportType)}
        >
          {item.label}
          {listType === item.value && (
            <span className="absolute left-1/2 -translate-x-1/2 bottom-0 w-3/4 h-[2px] bg-[#2E0D1E] rounded-t" style={{content: ''}} />
          )}
        </button>
      ))}
    </div>
  );
}
